import { Form } from "react-bootstrap";
import { useEffect, useState, useRef, useContext, useCallback } from "react";
import Button from 'react-bootstrap/Button';
import { AppContext } from "../context/AppContext";
import { toastMsg } from "../component/toast";


import {
  PostCallWithErrorResponse,
  simpleGetCallWithErrorResponse,
  simpleGetCall,
} from "../Api/ApiServices";
import { ApiConfig } from "../Api/ApiConfig";
import Select from "react-select";
import AddCompany from "./AddCompany";
import { expOptions } from "../constant/exprienceOpttion";
import { educationOptions } from "../constant/educationOpt";
import { optionsSalary } from "../constant/optionSalary";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Modal } from "react-bootstrap";
import CustomButton from "../component/button";
import { profiles } from "../constant/profile";
import { useDispatch } from "react-redux";
import { updateFormField } from "./Slices/formSlice";
import BehaviorsPage from "./BehaviorsPage";
import { Tooltip } from "antd";
import CustomSelect from "../constant/customselect";
import SupervisiorPersonality from "./supervissiorPer";
import CollaboratorsEmail from "./collabratoremail";
import CustomTabs from "../component/tabs";
import ScreeningCondition from "./ScreeningCondition";
import UploadFile from "../component/uploadFile";
import ChatScreenConfig from "./AiScreening/chatScreenConfig";

const initialScreeningCondition =  {
  "salaryAlignment": {
    "values": [],
    "isCritical": false
  },
  "availability": {
    "values": [],
    "isCritical": false
  },
  "relevantExperience": {
    "values": [],
    "isCritical": false
  },
  "totalExperience": {
    "values": [],
    "isCritical": false
  },
  "industryBackground": {
    "values": [],
    "isCritical": false
  },
  "educationArea": {
    "values": [],
    "isCritical": false
  },
  "customQuestion1": {
    "values": [],
    "isCritical": false
  },
  "customQuestion2": {
    "values": [],
    "isCritical": false
  }
}

function AddEditGroup() {
  const { code } = useParams();
  const [params] = useSearchParams();
  const [selectedBehaviorFromApi, setSelectedBehaviorFromApi] = useState({b1: 'Self Confidence', b2: 'Cooperativeness', b3: 'Patience', b4: 'Independence'})
  const [selectedBehavoiurTwo, setSelectedBehavoiurTwo] = useState([])
  console.log('selectedBehaviorFromApi--', selectedBehaviorFromApi)
  const [valiteded, setValiteded] = useState(false);
  const [showEmails, setShowEmails] = useState([]);
  const [groupListData, setGroupListData] = useState([]);
  const [error, setError] = useState("");
  const [isAddCompany, setIsAddCompany] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [selectedExp, setSelectedExp] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedArea, setSelectedArea] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState([]);
  const [industryList, setIndustryList] = useState([]);
  const [personalityMatchingData, setPersonalityMatchingData] = useState([]);
  const [matchTwoPersonliyt, setPersonalityMatchTwo] = useState([])
  const [showSuperVisior, setShowSuperVisior] = useState(false)
  const navigate = useNavigate();
  const optionsIndustry = industryList.map((x) => ({
    value: x.label,
    label: x.label,
  }));

  const [permission, setPermissions] = useState({})

  const [activeTab,setActiveTab] = useState('Job Details')

  const [isSuperVissorCloseWithSave, setIsSuperVissorVlaseWithSave] = useState(false)


  const { adminData } = useContext(AppContext);

  const [isSuperVission, setIsSuperVision] = useState(false)
  const values = [true];
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);

  function handleShow(breakpoint) {
    setFullscreen(breakpoint);
    setShow(true);
    setIsSuperVision(false)
  }
  function handleClose(breakpoint) {
    // setFullscreen(breakpoint);
    setShow(false);
  }

  const [isEdit, setIsEdit] = useState(false);
  const [enterEmail, setEnterEmail] = useState("");
  const [codeEdt, setCodeEdit] = useState(true);
  const [isAddNew, setIsAddNew] = useState(true);
  const [isActive, setIsActive] = useState(true);
  const [jdId, setjdId] = useState(null)
  const [areaList, setAreaList] = useState([]);
  const optionsArealist = areaList.map((x) => ({
    value: x.specializationName,
    label: x.specializationName,
  }));
  const [selectedSalary, setSelectedSalary] = useState([]);
  const [emailList, setEmailList] = useState([]);

  const profilePer = {
    codeId: 0,
    id: 0,
    pioneer: 40,
    influencer: 52,
    teamPlayer: 36,
    logicalThinker: 52,
    persuader: 80,
    achiever: 29,
    perfectionist: 6,
    collaborator: 74,
    assessor: 32,
    implementor: 67,
    motivator: 100,
    leader: 4,
    administrator: 0,
    mediator: 76,
    allRounder: 55,
    pioneer1: 30,
    influencer1: 30,
    teamPlayer1: 30,
    logicalThinker1: 30,
    persuader1: 30,
    achiever1: 30,
    perfectionist1: 30,
    collaborator1: 30,
    assessor1: 30,
    implementor1: 30,
    motivator1: 30,
    leader1: 30,
    administrator1: 30,
    mediator1: 30,
    allRounder1: 30,
  };

  const initialState = {
    id: 0,
    accessCode: "",
    reason: "",
    company: "",
    companyId: "",
    designation: "",
    additionalQs1: "no",
    additionalQs2: "no",
    address: "",
    linktoAssess: "",
    idealExp: [],
    eduLevel: [],
    eduArea: [],
    industry: [],
    salaryRange: "",
    startDate: "",
    primaryMatch: "",
    secoundryMatch: "",
    primaryProfile: "",
    secoundryProfile: "",
    association: "",
    isActive: true,
    from: "",
    isNormalAssesment: true,
    aboutJob: "",
    aboutCompany: "",
    quizSource: "Custom Quiz",
    isJDCode: false,
    quizes: [],
    selectedSupervisorPersonality: {
      "personalityName": "",
      "isSelected": true,
      "percentage": "",
      description: ''
    },
    supervisorBehaviours: [],
    "stressFrequency": {
      "value": "Sometimes",
      "isActive": false
    },
    "superVisorImportance": {
      "value": "Average",
      "isActive": false
    },
    cutomJdBase64:'',
    customJdName:''
  };

   const [config, setConfig] = useState({
          expiryDays: 7,
          channels: ['email', 'whatsapp'],
          activities: {
            interest: true,
            requirements: true,
            technical: true,
            behavior: false,
            logistics: true,
            referrals: false
          },
          timerMinutes: 3,
          questions: [
            { id: 1, text: "Describe a time you had to optimize a React component's rendering performance.", isClean: true, timerMinutes: 3 },
            { id: 2, text: "How old are you, and do you have family commitments that would prevent weekend work?", isClean: false, timerMinutes: 3 }
          ]
        });

  const [isAiscreening, setIsAiScreening] = useState(false)

  const [screeningCondition, setScreeningCondition] = useState(initialScreeningCondition)

  const [questions, setQuestions] = useState(
    new Array(3).fill(null).map((_, i) => ({
      questionText: "",
      questionNumber: 0,
      isActive: false
    }))
  );


  const dispatch = useDispatch()

  const inputRefs = useRef([]);

  const secoundRef = useRef([])

  const handleKeyDown = (e, index, isSecound = false) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (index < inputRefs.current.length - 1) {
        if (isSecound) {
          secoundRef.current[index + 1]?.focus();
        } else {
          inputRefs.current[index + 1]?.focus();
        }

      }
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (index > 0) {
        if (isSecound) {
          secoundRef.current[index - 1]?.focus();
        } else {
          inputRefs.current[index - 1]?.focus();
        }
      }
    }
  };

  const [quizList, setQuizList] = useState([])
  const [details, setDetails] = useState(initialState);
  const [jdInfrmId, setJdInformId] = useState(null)
  const [initialProfiles, setInitialProfiles] = useState(profilePer);
  const transformIndustryToOptions = (industries) => {
    if (!industries) return [];
    return industries.map((industry) => ({
      value: industry,
      label: industry,
    }));
  };

  const transformEduLevelToOptions = (eduLevels) => {
    if (!eduLevels) return [];
    return eduLevels.map((level) => ({
      value: level,
      label: level,
    }));
  };

  const handleAddCompamy = () => {
    getCompanies();

    setIsAddCompany(false);
  };

  const transformEduAreaToOptions = (eduAreas) => {
    if (!eduAreas) return [];
    return eduAreas.map((area) => ({
      value: area,
      label: area,
    }));
  };

  const transformSalaryToOptions = (salaryRanges) => {
    if (!salaryRanges) return [];
    return salaryRanges.map((range) => ({
      value: range,
      label: range,
    }));
  };
  const transformExpToOptions = (experiences) => {
    if (!experiences) return [];
    return experiences.map((exp) => ({
      value: exp,
      label: exp.replace("-", " to ") + " Yrs",
    }));
  };

  const getEmailList = () => {
    simpleGetCallWithErrorResponse(ApiConfig.GET_AUTHENTICATED_SENDERS)
      .then((res) => {
        if (res?.json) {
          setEmailList(res.json);
        } else {
          setEmailList([]);
        }
      })
      .catch((err) => console.log(err));
  };

  const getAllspecialization = () => {
    simpleGetCall(ApiConfig.GET_AREA_OF_EDUCATION)
      .then((res) => {
        if (res.succeded) {
          setAreaList(res.response);
          console.log(res.response);
        } else {
          setAreaList([]);
        }
      })
      .catch((err) => console.log(err));
  };

  const getAllIndustryList = () => {
    simpleGetCall(ApiConfig.GET_INDUSTRY_LIST)
      .then((res) => {
        if (res.succeded) {
          setIndustryList(res?.response);
        } else {
          setIndustryList([]);
        }
      })
      .catch((err) => console.log(err));
  };
  const getCompanies = () => {
    simpleGetCall(ApiConfig.GET_COMPANY_LIST).then((res) => {
      if (res?.succeded) {
        let companiesList = res?.response?.map((i) => ({
          value: i?.id,
          label: i?.companyName,
          aboutCompany: i?.aboutCompany,
        }));

        companiesList[0] = {
          value: "",
          label: "Add Company Name",
        };

        setCompanies(companiesList);
      } else {
        setCompanies([]);
      }
    });
  };

  const getEditData = (id = "") => {
    setIsEdit(true);

    simpleGetCallWithErrorResponse(ApiConfig.GET_CODE_DETAILS + code + `&email=${adminData?.email}`).then(
      (res) => {
        console.log(res);

        if (res?.json?.succeded) {
          const responseData = res?.json?.response;
          setSelectedIndustry(
            transformIndustryToOptions(responseData?.idealIndustry)
          );
          setSelectedOptions(
            transformEduLevelToOptions(responseData?.idealEducationLevel)
          );
          setSelectedArea(
            transformEduAreaToOptions(responseData?.idealEducationArea)
          );
          setSelectedSalary(
            transformSalaryToOptions(responseData?.idealSalaryRange)
          );
          setSelectedExp(transformExpToOptions(responseData?.idealExperience));

          // Set ideal experience
          // setIdealExp(responseData?.idealExperience || []);

          setActiveTab( res?.json?.response?.reason === "Job Application"?'Job Details':'Internal Assessment')

          setJdInformId(id)

          setDetails({
            isActive: id ? true : res?.json?.response?.isActive,
            id: id ? 0 : res?.json?.response?.id,
            accessCode: id ? "" : code,
            reason: res?.json?.response?.reason,
            company: res?.json?.response?.company,
            companyId: res?.json?.response?.companyId,
            designation: res?.json?.response?.position,
            additionalQs1: res?.json?.response?.additionalPart1,
            additionalQs2: res?.json?.response?.primaryMatch,
            primaryMatch: res?.json?.response?.primaryMatch,
            secoundryMatch: res?.json?.response?.secondaryMatch,
            primaryProfile: res?.json?.response?.primaryId,
            secoundryProfile: res?.json?.response?.secondaryId,
            association: res?.json?.response?.codeAssociation,
            quizSource: id ? "Saved Quiz" : res?.json?.response?.quizSource,
            isNormalAssesment: res?.json?.response?.isNormalAssesment,
            address: res?.json?.response?.addressOfSheet,
            linktoAssess: res?.json?.response?.linkToAssessment,
            from: res?.json?.response?.fromEmail,
            idealExp: res?.json?.response?.idealExperience,
            eduLevel: res?.json?.response?.idealEducationLevel,
            eduArea: res?.json?.response?.idealEducationArea,
            industry: res?.json?.response?.idealIndustry,
            salaryRange: res?.json?.response?.idealSalaryRange,
            aboutCompany: res?.json?.response?.aboutCompany,
            aboutJob: res?.json?.response?.aboutJob,
            isJDCode: res?.json?.response?.isJDCode,
            quizes: res?.json?.response?.quizes,
            startDate:
              res?.json?.response?.reason === "Job Application"
                ? res?.json?.response?.idealStartDate
                  ? res?.json?.response?.idealStartDate
                    .split("T")[0]
                    .split("-")
                    .join("-")
                  : null
                : null,
            selectedSupervisorPersonality: res?.json?.response?.selectedSupervisorPersonality,
            supervisorBehaviours: res?.json?.response?.supervisorBehaviours,
            stressFrequency: res?.json?.response?.stressFrequency,
            superVisorImportance: res?.json?.response?.superVisorImportance,
            customJdName: res?.json?.response?.customJdName,
            cutomJdBase64: res?.json?.response?.cutomJdBase64
          });

          setScreeningCondition(res?.json?.response?.screeningRequirements || initialScreeningCondition)


          setPermissions(res?.json?.permission)

          setSelectedBehavoiurTwo(res?.json?.response?.behaviours1)

          if (res?.json?.response?.behaviours?.length === 4) {
            let obj = {
              b1: res?.json?.response?.behaviours[0],
              b2: res?.json?.response?.behaviours[1],
              b3: res?.json?.response?.behaviours[2],
              b4: res?.json?.response?.behaviours[3],
            }
            setSelectedBehaviorFromApi(obj)

          }


          if (res?.json?.response?.questions?.length > 0) {


            let quest = res?.json?.response?.questions?.map((q, index) => {

              if (index > 5) {
                return {
                  questionText: q.questionText,
                  questionNumber: q.questionNumber,
                  isActive: false,
                }
              }
              return q

            })


            setQuestions(quest)
          }


          // if (Array.isArray(responseData?.behaviours) && responseData?.behaviours?.length > 0) {
          //   const behaviours = responseData?.behaviours;
          //   const behaviourObj = behaviours.reduce((acc, behaviour, index) => {
          //     acc[`b${index + 1}`] = behaviour;
          //     return acc;
          //   }, {});
          //   setSelectedBehaviorFromApi(behaviourObj)
          // }

          // handleShow();
          setShowEmails(res?.json?.response?.users || []);
          if (res?.json?.response?.reason === "Job Application") {



            if (res?.json?.response?.profilePer && !id) {
              setInitialProfiles(res?.json?.response?.profilePer);
            }
          }
        } else {
          toastMsg("error", res?.json?.message);
        }
      }
    );
  };
  const copyCode = (code) => {
    navigator.clipboard.writeText(
      // "https://lywouserweb.app.cloudxperte.com/?code=" + code
      // "http://localhost:3000/?code=" + code
      "https://apply.lywo.in/?code=" + code
    );
  };

  const getSavedQuiz = (id = null) => {



    simpleGetCall(ApiConfig.GET_TEMP_JOB_CODE + code+`&email=${adminData?.email}`).then((res) => {

      if (res?.succeded) {
        if (res?.response?.length === 0) {
          if (id) {
            setTimeout(() => {
              handleChage("quizSource", "None")

            }, [300])
          }
        }
        setQuizList(res?.response)
      }

    })



  }


  const hadlePayload = () => {
    const payload = {
      id: details.id,
      isActive: details.isActive,
      code: details.accessCode,
      codeAssociation: details.association,
      position: details.designation,
      reason: details.reason,
      company: details.company,
      companyId: details?.companyId,
      additionalPart1: details.additionalQs1,
      additionalPart2: details.additionalQs2,
      primaryId: details.primaryProfile,
      secondaryId: details.secoundryProfile,
      primaryMatch: details.primaryMatch,
      secondaryMatch: details.secoundryMatch,
      profilePer: details.reason === "Job Application" ? initialProfiles : {},
      users: showEmails,
      addressOfSheet: details.address,
      fromEmail: details.from,
      linkToAssessment: details.linktoAssess,
      idealExperience: details.idealExp,
      idealEducationLevel: details.eduLevel,
      idealEducationArea: details.eduArea,
      idealIndustry: details.industry,
      idealSalaryRange: details.salaryRange,
      idealStartDate: details.startDate,
      isNormalAssesment: details.isNormalAssesment,
      aboutCompany: details?.aboutCompany,
      aboutJob: details?.aboutJob,
      quizSource: details?.quizSource,
      quizes: details?.quizes,
      questions: questions,
      "behaviours": Object.values(selectedBehaviorFromApi),
      "behaviours1": selectedBehavoiurTwo,
      "supervisorBehaviours": details?.supervisorBehaviours,
      selectedSupervisorPersonality: details?.selectedSupervisorPersonality?.personalityName ? details?.selectedSupervisorPersonality : null,
      stressFrequency: details?.stressFrequency,
      superVisorImportance: details?.superVisorImportance,
      screeningRequirements:screeningCondition,
      customJdName: details.customJdName,
      cutomJdBase64: details.cutomJdBase64
    };

    if (jdInfrmId) {
      payload.jdJobInformationId = Number(jdInfrmId);
    }

    return payload;
  }

  useEffect(() => {
    let type = params.get("type");


    if(type){

      let t =decodeURIComponent(type)
      setDetails(prev => ({
        ...prev,
        reason: t
      }))

      setActiveTab(t=='Internal Assessment'?'Internal Assessment':'Job Details')
    }
  },[])

  useEffect(() => {

    

    if (!params.get("isAccessCode")?.length) {
      setCodeEdit(false);
    }

    let id = params.get('detailsId')


    getAllIndustryList();
    getAllspecialization();
    getEmailList();
    getCompanies();
    if (code !== "new" && code) {

      setIsAddNew(false);
      getEditData(id);
      getSavedQuiz(id)
    } else {
      handleChage("quizSource", "None")
    }
  }, []);


  const handleNavigation =(isNext=true)=>{

    if(activeTab==='Job Details'){
      setActiveTab('Screening Conditions')
      return
    }

    if(activeTab==='Screening Conditions'){
      setActiveTab(isNext ? 'Personality Fitment' : 'Job Details')
      return
    }

    if(activeTab==='Personality Fitment'){
      // forward navigation on the final tab is a save (handled in handleSubmit);
      // only backward (Previous) navigation reaches here

      if(isNext){
        setActiveTab('Ai Chat Screening')
      }

      if(!isNext){
        setActiveTab('Screening Conditions')
      }
      return
    }

    if(activeTab==='Ai Chat Screening'){
      setActiveTab('Personality Fitment')
      return
    }

  }



  const handleSubmit = (event,tab='') => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (!form.checkValidity()) {
      console.log(form.checkValidity());
      setValiteded(true);


      return;
    }
  

    
    // if(activeTab==='Job Details'|| activeTab=='Internal Assessment'){

    if (!details) {
      console.error("Details are not defined");
      return;
    }

    const urlRegex = /^(https?:\/\/[^\s$.?#].[^\s]*)$/;
    const googleDocsRegex = /https?:\/\/docs\.google\.com\//;

    // const customQuestion1 = details.additionalQs1.trim();
    // if (customQuestion1 && customQuestion1 !== "YES" && customQuestion1 !== "NO") {
    //   toastMsg("error", "Custom Question 1 must be 'YES' or 'NO' if entered");
    //   return;
    // }

    // const customQuestion2 = details.additionalQs2.trim();
    // if (customQuestion2 && customQuestion2 !== "YES" && customQuestion2 !== "NO") {
    //   toastMsg("error", "Custom Question 2 must be 'YES' or 'NO' if entered");
    //   return;
    // }

    // const customQuestion3 = details.additionalQs3.trim();
    // if (customQuestion3 && customQuestion3 !== "YES" && customQuestion3 !== "NO") {
    //   toastMsg("error", "Custom Question 3 must be 'YES' or 'NO' if entered");
    //   return;
    // }

    if (details.address && !googleDocsRegex.test(details.address)) {
      toastMsg(
        "error",
        "Please enter a valid Google Document link for 'Address of the Sheet"
      );
      return;
    }

    if (details.linktoAssess && !urlRegex.test(details.linktoAssess)) {
      toastMsg(
        "error",
        "Please enter a valid hyperlink for 'Link to Assessment'"
      );
      return;
    }

    if (details.accessCode.length !== 7) {
      toastMsg("error", "Please enter a 7-digit valid access code");
      return;
    }

    // if (showEmails.length === 0 && details.reason === "Job Application") {
    //   toastMsg("error", "Please add users");
    //   return;
    // }

    if (!details?.companyId) {
      setValiteded(true)
      // toastMsg("error", "Please Select Company Name");
      return;
    }
  


  if(details.reason==='Job Application'){

    if(tab){
      setActiveTab(tab)
      return
    }

    // advance through the tabs; only the final tab (Personality Fitment)
    // falls through to the actual save below


    if (
  (isAiscreening && activeTab !== 'Ai Chat Screening') ||
  (!isAiscreening && activeTab !== 'Personality Fitment')
) {
  handleNavigation();
  return;
}

  }

  if(tab) return

    

    let payload = hadlePayload()



    PostCallWithErrorResponse(ApiConfig?.ADD_JOB, payload)
      .then((res) => {

        if (res?.json?.succeded) {
          // setIsEdit(false);
          toastMsg("success", res?.json?.response?.statusMessage);

          navigate(-1)
        } else {
          toastMsg("error", res?.json?.response?.statusMessage);
        }
      })
      .catch((err) => {
        console.error("Something went wrong:", err);
      });
  };

  const handleChage = (key, val) => {
    if (key === "reason") {
      let prt1 = "";
      let part2 = "";

      if (
        val === "Individual User" ||
        val === "Investor" ||
        val === "Investor as Individual User"
      ) {
        prt1 = "no";
        part2 = "no";
      }

      if (val === "Job Application") {
        prt1 = "yes";
        part2 = "no";
      }

      if (val === "Internal Assessment") {
        prt1 = "no";
        part2 = "yes";
      }

      setDetails((prev) => ({
        ...prev,
        reason: val,
        additionalQs1: prt1,
        additionalQs2: part2,
      }));
      const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/;
      if (!urlPattern.test(details.linktoAssess)) {
        setError("Please enter a valid hyperlink (e.g., https://example.com)");
      } else {
        setError("");
      }

      return;
    }

    setDetails((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  const removeEmail = useCallback((indexToRemove) => {
    const updatedEmails = showEmails.filter(
      (_, index) => index !== indexToRemove
    );
    setShowEmails(updatedEmails);
  }, [showEmails]);

  const handleProfiles = (key, val) => {
    setInitialProfiles((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  const handleExpChange = (selected) => {
    setSelectedExp(selected || []);
    setDetails({ ...details, idealExp: selected ? [selected.value] : [] });
    console.log(details);
  };

  const handleChangemulti = (selected) => {
    setSelectedOptions(selected || []);

    const selectedValues = (selected || []).map((option) => option.value);
    setDetails({ ...details, eduLevel: selectedValues });
    console.log(details);
  };

  const handleMultiArea = (selected) => {
    setSelectedArea(selected || []);
    const selectedValues = (selected || []).map((option) => option.value);
    setDetails({ ...details, eduArea: selectedValues });
    console.log(details);
  };

  const handleMultiIndustry = (selected) => {
    setSelectedIndustry(selected || []);
    const selectedValues = (selected || []).map((option) => option.value);
    setDetails({ ...details, industry: selectedValues });
    console.log(details);
  };

  const handleMultiSalary = (selected) => {
    setSelectedSalary(selected || []);
    const selectedValues = (selected || []).map((option) => option.value);
    setDetails({ ...details, salaryRange: selectedValues });
    console.log(details);
  };

  const handleAddEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (enterEmail.trim() !== "") {
      if (!emailRegex.test(enterEmail)) {
        toastMsg("error", "Please Enter Valid User Email");
        return;
      }

      let index = showEmails.findIndex((i) => i.email === enterEmail);

      if (index != -1) {
        toastMsg("error", "Email Already Added");
        return;
      }

      setShowEmails([
        ...showEmails,
        {
          codeId: 0,
          email: enterEmail,
          "isDailyReportEnabled": false,
          "isEditEnabled": true,
          "isViewEnabled": true
        },
      ]);

      setEnterEmail("");
    }
  };


  const addQuize = () => {

    if (details?.aboutJob?.length == 0) {
      toastMsg('error', 'Please Enter Invitation To Apply')
      return
    }

    dispatch(updateFormField({ field: 'finalSelectedJobDescription', value: details?.aboutJob }))
    dispatch(updateFormField({ field: 'tempJobCode', value: code }))
    dispatch(updateFormField({ field: 'isAddQuizFromAddCode', value: true }))

    dispatch(updateFormField({ field: 'jdId', value: jdInfrmId }))

    navigate("/Topics")

  }
  const toCamelCase = (str) =>
    str
      .trim() // remove leading/trailing spaces
      .split(" ")
      .map((word, index) =>
        index === 0
          ? word.charAt(0).toLowerCase() + word.slice(1)
          : word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join("");

  const calucluatePersonalityPercentage = () => {



    console.log('personalityMatchingData--', personalityMatchingData)


    let formatData = {
      ...personalityMatchingData?.reduce((acc, item) => {
        const camelKey = toCamelCase(item.name);
        acc[camelKey] = item.percentage;
        return acc;
      }, {}),
      allRounder: 55,
    };


    formatData = {

      ...formatData,
      ...matchTwoPersonliyt?.reduce((acc, item) => {
        const camelKey = toCamelCase(item.name) + '1';
        acc[camelKey] = item.percentage;
        return acc;
      }, {}),
      allRounder1: 55,
    };



    setInitialProfiles(prev => ({
      ...prev,
      ...formatData
    }))

  }
  useEffect(() => {
    if (personalityMatchingData?.length > 0 | matchTwoPersonliyt?.length > 0) {
      calucluatePersonalityPercentage()
    }
  }, [personalityMatchingData, matchTwoPersonliyt])

  const openBase64InNewTab = (base64) => {
  let mimeType = "application/pdf";
  let rawBase64 = base64;

  if (base64.includes(",")) {
    mimeType = base64.split(",")[0].match(/:(.*?);/)[1];
    rawBase64 = base64.split(",")[1];
  }

  const byteString = atob(rawBase64);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([ab], { type: mimeType });
  const url = URL.createObjectURL(blob);
  window.open(url, "_blank");
};

  const handleAddQuestion = () => {

    setQuestions(prev => ([
      ...prev,
      {
        "questionText": "",
        "questionNumber": 0,
        "isActive": false,
        isNew: true,
      }
    ]))

  }

  const handelQuestion = (index, key, val, prevText = '') => {

    let questionsUpdate = [...questions]


    questionsUpdate[index][key] = val

    if (key == 'questionText' && val.trim().length == 1 && prevText.length != 2) {
      questionsUpdate[index]['isActive'] = true
    } else if (key == 'questionText' && val.trim().length == 0) {
      questionsUpdate[index]['isActive'] = false
    }

    setQuestions(questionsUpdate)

  }

  const tabs =[
    {
      name:details.reason === "Job Application"?"Job Details" :'Internal Assessment',
      isRequired:true,
      isVisiable:true,
    },
    {
      name:"Screening Conditions",
      isRequired:false,
      isVisiable:details.reason === "Job Application",
    },
    {
      name:"Personality Fitment",
      isRequired:false,
      isVisiable:details.reason === "Job Application"
    },
    {
      name:"Ai Chat Screening",
      isRequired:false,
      isVisiable:details.reason === "Job Application" && isAiscreening
    },
  ]

  const getButtonText = () => {

    switch(activeTab){
      case 'Job Details':
        return 'Next'
      case 'Screening Conditions':
        return 'Next'
      case 'Personality Fitment' :
        return isAiscreening?"Next": isEdit ? 'Update' : 'Save'
      case 'Ai Chat Screening':
        return isEdit ? 'Update' : 'Save'
      default:
        return isEdit ? 'Update' : 'Save'
    }
    
  }


  const buttonText =
  details.reason === 'Job Application' &&
  activeTab !== 'Personality Fitment'
    ? 'Next'
    : isEdit
    ? 'Update'
    : 'Save';

  return (
    <div
      className={`canLisContentWrap bg-ui-gray`}>
      <div
        className="candListBox paddingTop"
        style={{ marginTop: '10px' }}
      >

        <div className="p-2">
          <div closeButton className="custom-close-btn">
            <div className="d-flex justify-content-between">
              {/* <h4 className="custom-modal-title">Add/ Edit Group</h4> */}
              <div>
              <h4 className="heading-groupmain ">{codeEdt?'Edit ':'Add '} Group
              </h4>
              <p className="text-muted">Configure job, screening and personality fitment.</p>
              </div>

              <button
                className="btn-close"
                style={{ width: '6px', height: '6px' }}
                onClick={() => {
                  navigate(-1);
                }}
              ></button>
            </div>
            <CustomTabs 
            tabs={tabs}
            activeTab={activeTab}
            handleTabs={(e,tab) =>{

              if(tab===activeTab) return

              handleSubmit(e,tab)

            }}
            />
            {/* <hr style={{ marginTop: '5px' }} /> */}
          </div>
          <div style={{ marginTop: '15px' }}>
            <Form noValidate validated={valiteded} onSubmit={handleSubmit}>
              <div 
              style={{
                height: "65vh",
                overflowY: "auto",
                overflowX: "hidden",
              }}
              >
              {
               ( activeTab === 'Job Details' || activeTab==="Internal Assessment") && (<>
              <div className=" mt-1">
                
                  
                  {details.reason === "Job Application" && (
                <div>
                  <Form.Label className="job_size">
                    Invitation to Apply
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4} // number of visible lines
                    value={details?.aboutJob}
                    disabled={adminData?.admin != "Admin"}
                    style={{ marginTop: '-5px' }}
                    onChange={(e) => handleChage("aboutJob", e.target.value)}
                    placeholder="Enter Invitation to Apply"
                    className="textarea-placeholder-14"
                  />
                </div>
                  )}
                <div className={details.reason === "Job Application"?"mt-1":""}>
                  {/* <h4 className="fw-bold">About Company</h4> */}

                  <Form.Label className="job_size">
                    About Company
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4} // number of visible lines
                    placeholder="Enter About Company"
                    value={details?.aboutCompany}
                    disabled={adminData?.admin != "Admin"}
                    className="textarea-placeholder-14"
                    style={{ marginTop: '-5px' }}
                    onChange={(e) =>
                      handleChage("aboutCompany", e.target.value)
                    }
                  />
                </div>
              </div>
              <div className="row mt-2">
                <div
                  className="col-md-12"
                >
                  <h4 className="heading-group" style={{ marginTop: '3px' }}>Job Details</h4>
                {
                    details?.reason === "Job Application" && 
<div className="d-flex align-items-center ">
                    <div className="col-12" >
                      <Form.Group
                        controlId="accessCode"
                        className="margin-btn-input"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Form.Label className="job_size col-md-2">
                          Job Description
                        </Form.Label>
                        <div
                          className="col-md-8"
                          style={{
                            flex: 1,
                          }}
                        >
                          <div style={{width:"90%"}}>
<UploadFile
                      title={details?.customJdName?.length > 0 ? 'Want To Change Job Description? Please Upload New File' : 'Have A Job Description? Please Upload'}
                      accept='.pdf'
                      fileName={details?.customJdName}
                      fileData={details?.cutomJdBase64}
                      isDisabled={adminData?.admin != "Admin"}
                      handleFile={(file,fileName)=>{

                        setDetails(prev => ({
                          ...prev,
                          customJdName: fileName,
                          cutomJdBase64: file
                        }))

                      }}
                      handlePreview={openBase64InNewTab}
                      />
                          </div>
                          
                        </div>
                      </Form.Group>
                    </div>

                  </div>
 } 
                  <div className="d-flex align-items-center ">
                    <div className="col-12" >
                      <Form.Group
                        controlId="accessCode"
                        className="margin-btn-input"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Form.Label className="job_size col-md-2">
                          Access Code
                        </Form.Label>
                        <div
                          className="col-md-8"
                          style={{
                            flex: 1,
                          }}
                        >
                          <Form.Control
                            style={{ width: "90%" }}
                            type="text"
                            placeholder="Access Code"
                            id="accessCode"
                            disabled={codeEdt}
                            value={details.accessCode}
                            className="input-text-14 col-md-9 font-size-h4"
                            minLength={7}
                            maxLength={7}
                            required
                            isInvalid={
                              valiteded && details.accessCode.length != 7
                            }
                            onChange={(e) => {
                              const input = e.target.value.toUpperCase();
                              const filtered = input.replace(/[^A-Z0-9]/g, "");

                              handleChage("accessCode", filtered);
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter 7 Digit Valid Code!
                          </Form.Control.Feedback>
                        </div>
                      </Form.Group>
                    </div>

                    {/* <div className="col-3 ms-5 d-flex mt-3">
                    <Form.Check
                      type="checkbox"
                      onClick={handleClickcheck}
                    ></Form.Check>
                    {checked ? (
                      <Form.Label className="ms-3">Deactive</Form.Label>
                    ) : (
                      <Form.Label className="ms-3">Active</Form.Label>
                    )}
                  </div> */}
                  </div>
                  {/* <div className=" col-auto">
                      <div className="col-md-3"></div>

                      <div className="d-flex gap-2">
                        <span className="job_size col-md-2">Status</span>
                        <div>
                          <label
                            className="radio-label form-label"
                            onClick={() => {
                              handleChage("isActive", false);
                            }}
                          >
                            <input
                              type="radio"
                              id="inActive"
                              name="statusInActive"
                              checked={!details?.isActive}
                              value={!details?.isActive}
                              placeholder="inActive"
                            />
                            <span for="inActive" className="active-inac">
                              In Active{" "}
                            </span>
                          </label>
                        </div>
                        <div>
                          <label
                            className="radio-label form-label"
                            onClick={() => {
                              handleChage("isActive", true);
                            }}
                          >
                            <input
                              type="radio"
                              id="Active"
                              name="statusActive"
                              checked={details?.isActive}
                              value={details?.isActive}
                              placeholder="Active"
                            />
                            <span for="inActive" className="active-inac ml-3">
                              Active{" "}
                            </span>
                          </label>
                        </div>
                      </div>
                    </div> */}
                  <div className="row " style={{height:'35px'}}>
                    <Form.Group className="row align-items-center">
                      {/* Label */}
                      <Form.Label className="job_size col-md-2 mb-0 d-flex align-items-center">
                        Status
                      </Form.Label>

                      {/* Radio Buttons */}
                      <div className="col-md-10 d-flex gap-3 align-items-center">
                        <label
                          className="radio-label d-flex align-items-center gap-2"
                          onClick={() => handleChage("isActive", false)}
                        >
                          <input
                            type="radio"
                            id="inActive"
                            name="status"
                            checked={!details?.isActive}
                            disabled={isEdit && !permission?.isEdit}
                            value={false}
                          />
                          <span className="active-inac">Inactive</span>
                        </label>

                        <label
                          className="radio-label d-flex align-items-center gap-2"
                          onClick={() => handleChage("isActive", true)}
                        >
                          <input
                            type="radio"
                            id="Active"
                            name="status"
                            checked={details?.isActive}
                            disabled={isEdit && !permission?.isEdit}
                            value={true}
                          />
                          <span className="active-inac">Active</span>
                        </label>
                      </div>
                    </Form.Group>

                  </div>

                  {/*                 
                <Form.Group controlId="accessCode" className="mb-3">
                  <Form.Label>Access Code</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Access Code"
                    id="accessCode"
                    value={details.accessCode}
                    minLength={7}
                    maxLength={7}
                    required
                    isInvalid={valiteded && details.accessCode.length != 7}
                    onChange={(e) =>
                      handleChage("accessCode", e.target.value.toUpperCase())
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    Please Enter 7 Digit Valid Code!
                  </Form.Control.Feedback>
                </Form.Group> */}
                  {/* <div className="row mt-1">
                    <Form.Group
                      controlId="reason"
                      className="col-md-12 margin-btn-input"
                      style={{ display: "flex" }}
                    >
                      <Form.Label className="job_size col-md-2 mt-2">
                        Application Type
                      </Form.Label>
                      <div
                        className="col-md-8"
                        style={{
                          flex: 1,

                          borderRadius: "5px",
                          width: "90%",
                        }}
                      >
                        <Form.Select
                          disabled={!isAddNew || adminData?.admin != "Admin"}
                          required
                          value={details?.reason}
                          onChange={(e) => {
                            setValiteded(false);
                            handleChage("reason", e.target.value);
                            if (e.target.value == 'Internal Assessment') {
                              handleChage("quizSource", "None")
                            }
                          }}
                          className="input-text-14 font-size-h4"
                        >
                          <option disabled value={""}>
                            Select reason
                          </option>
                          <option
                            value="Job Application"
                            className="job_size"
                          >
                            Job Application
                          </option>

                          <option
                            value="Internal Assessment"
                            className="job_size"
                          >
                            Internal Assessment
                          </option>

                        </Form.Select>
                        <Form.Control.Feedback
                          type="invalid"
                        >
                          Please Select Reason!
                        </Form.Control.Feedback>
                      </div>
                      <div className="col-md-1"></div>
                    </Form.Group>
                  </div> */}
                  {details?.reason !== "Individual User" &&
                    details?.reason !== "Investor" &&
                    details?.reason !== "" && (
                      <>
                        <div
                          className="mb-1 mt-1 mt-0 col-md-12"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <label
                            className="form-label job_size col-md-2"
                            style={{ display: "flex" }}
                          >
                            Company Name
                          </label>
                          <div className="col-md-9">
                            <CustomSelect
                              options={companies}
                              labelKey={'label'}
                              valKey={'value'}
                              isDisabled={adminData?.admin != "Admin"}
                              value={details?.companyId}
                              handleChange={(e, data) => {
                                console.log(data);
                                handleChage("aboutCompany", data?.details.aboutCompany);
                                setDetails(prev => ({
                                  ...prev,
                                  companyId: e,
                                  company: data?.label
                                }))
                              }}
                              // size="small"
                              isClearaAble={false}
                            />
                            {
                              valiteded && !details?.companyId &&
                              <div className="invalid-feedback d-block">
                                Please select Company
                              </div>
                            }

                          </div>

                          <div
                            className="col-md-1 "
                            style={{ marginLeft: "4px", marginTop: '5px' }}
                          >
                            <CustomButton
                              isLoading={false}
                              title={details?.companyId ? "Edit" : "Add"}
                              handleClick={() => setIsAddCompany(true)}
                              buttonType="buutonTertiory"
                              isDisabled={adminData?.admin != "Admin"}
                            />

                          </div>
                        </div>
                      </>
                    )}
                  {details.reason === "Job Application" && (
                    <Form.Group
                      controlId="designation"
                      className=""
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Form.Label className="job_size  col-md-2">
                        Designation
                      </Form.Label>
                      <div
                        className="col-md-8"
                        style={{
                          flex: 1,
                        }}
                      >
                        <Form.Control

                          type="text"
                          className="input-text-14 col-md-9 font-size-h4"
                          required
                          disabled={adminData?.admin != "Admin"}
                          placeholder="Designation"
                          style={{ width: "90%" }}
                          value={details?.designation}
                          onChange={(e) => {

                            if (e.target.value.length > 80) {
                              toastMsg("error", "Designation cannot exceed 80 characters");

                              return
                            }
                            handleChage("designation", e.target.value)
                          }
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Designation!
                        </Form.Control.Feedback>
                      </div>
                    </Form.Group>
                 )} 



                  {(details.reason === "Job Application" || details.reason === "Internal Assessment") && (
                    <div className="">

                      <div className="row " >
                        <h4 className="heading-group" >Assessment</h4>
                        {/* Assessment Type */}
                        <Form.Group className="row align-items-center" style={{height:"38px"}}>
                          {/* Label */}
                          <Form.Label className="job_size col-md-2 d-flex align-items-center mt-1">
                            Assessment Type
                          </Form.Label>

                          {/* Radio Buttons */}
                          <div className="col-md-10 d-flex gap-4 align-items-center">
                            {/* Short Option */}
                            <label
                              className="radio-label d-flex align-items-center gap-2"
                              onClick={() => !codeEdt && handleChage("isNormalAssesment", false)}
                            >
                              <input
                                type="radio"
                                id="short"
                                name="assessmentType"
                                checked={!details?.isNormalAssesment}
                                disabled={adminData?.admin != "Admin" || codeEdt}
                                value={false}
                              />
                              <span className="active-inac">Short</span>
                            </label>

                            {/* Normal Option */}
                            <label
                              className="radio-label d-flex align-items-center gap-2"
                              onClick={() => !codeEdt && handleChage("isNormalAssesment", true)}
                            >
                              <input
                                type="radio"
                                id="normal"
                                name="assessmentType"
                                disabled={adminData?.admin != "Admin" || codeEdt}
                                checked={details?.isNormalAssesment}
                                value={true}
                              />
                              <span className="active-inac">Normal</span>
                            </label>
                          </div>
                        </Form.Group>

                         {
                          details.reason === "Job Application" && 
                          <>
                            {/* Quiz Source */}
                            <Form.Group className="col-md-12  d-flex align-items-center" style={{height:"38px"}}>
                              <Form.Label className="job_size col-md-2 mt-1">
                                Quiz Source
                              </Form.Label>

                              <div className="col-md-10 d-flex gap-3 align-items-center">



                                <label className="radio-label form-label d-flex align-items-center gap-2">
                                  <input
                                    type="radio"
                                    id="savedQuiz"
                                    name="quizSource"
                                    checked={details?.quizSource === "Saved Quiz"}
                                    onChange={() =>
                                      handleChage("quizSource", "Saved Quiz")
                                    }
                                    disabled={!details?.isJDCode || quizList?.length === 0 || adminData?.admin != "Admin" || codeEdt}
                                  />
                                  <span className="active-inac fw-normal">Saved Quiz</span>
                                </label>

                                <label className="radio-label form-label d-flex align-items-center gap-1">
                                  <input
                                    type="radio"
                                    id="customQuiz"
                                    name="quizSource"
                                    checked={
                                      details?.quizSource === "Custom Quiz"
                                    }
                                    onChange={() =>
                                      handleChage("quizSource", "Custom Quiz")
                                    }
                                    disabled={adminData?.admin != "Admin" || codeEdt}
                                  />
                                  <span className="active-inac fw-normal">Custom Quiz</span>
                                </label>


                                <label className="radio-label form-label d-flex align-items-center gap-1">
                                  <input
                                    type="radio"
                                    id="noneQ"
                                    name="quizSource"
                                    checked={details?.quizSource === "None"}
                                    onChange={() =>
                                      handleChage("quizSource", "None")
                                    }
                                    disabled={adminData?.admin != "Admin" || codeEdt}
                                  />
                                  <span className="active-inac fw-normal">None</span>
                                </label>
                              </div>
                            </Form.Group>
                          </>
                       } 
                      </div>
                      {
                        details.reason === "Job Application" && 
                        <>
                          <>
                            <Form.Group
                              className="margin-btn-input"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Form.Label className="job_size col-md-2 mt-2"
                              >
                                Address of the Sheet
                              </Form.Label>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  width: "90%",
                                }}
                              >
                                <Form.Control
                                  style={{ width: "90%" }}
                                  className="input-text-14 col-md-9"
                                  required={details?.quizSource === "Custom Quiz"}
                                  type="text"
                                  value={details.address}
                                  onChange={(e) =>
                                    handleChage("address", e.target.value)
                                  }
                                  disabled={details.quizSource !== "Custom Quiz" || adminData?.admin != "Admin"}
                                />
                                {
                                  details?.quizSource === "Custom Quiz" &&

                                  <Form.Text>
                                    <span style={{ color: (valiteded && details?.quizSource === "Custom Quiz") ? 'var(--color-danger-text)' : '' }}>

                                      {!details.address && ("Please enter a valid google document link")}
                                      (for accessing the Score(Score
                                      in Column C, Email in Column B))
                                    </span>
                                  </Form.Text>
                                }

                              </div>
                            </Form.Group>

                            <Form.Group
                              className="job_size margin-btn-input"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Form.Label
                                className="col-md-2 mt-1"

                              >
                                Link to Assessment
                              </Form.Label>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  width: "90%",
                                }}
                              >
                                <Form.Control
                                  style={{ width: "90%" }}
                                  className="input-text-14 col-md-9"
                                  type="text"
                                  required={details?.quizSource === "Custom Quiz"}
                                  value={details.quizSource == 'Saved Quiz' ? 'https://quiz.lywo.in/' : details.linktoAssess}
                                  onChange={(e) =>
                                    handleChage("linktoAssess", e.target.value)
                                  }
                                  disabled={details.quizSource !== "Custom Quiz" || adminData?.admin != "Admin"}
                                // isInvalid={!!error}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {!details.linktoAssess && 'Please enter a valid link to assesment'}
                                </Form.Control.Feedback>
                              </div>
                            </Form.Group>

                            <Form.Group
                              className=""
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Form.Label className="job_size col-md-2 mt-1"
                              >
                                Saved Quiz
                              </Form.Label>
                              <div
                                className="col-md-8 d-flex flex-column"
                                style={{ flex: 1, borderRadius: "5px", width: "90%" }}
                              >
                                <Form.Select
                                  className="form-select font-size-h4"
                                  style={{ height: '32px' }}
                                  value={details?.quizes && details.quizes[0] ? details?.quizes[0] : ""}
                                  onChange={(e) => handleChage("quizes", [e.target.value])}
                                  required={details?.quizSource === "Saved Quiz"}
                                  disabled={details.quizSource != 'Saved Quiz' || adminData?.admin != "Admin" || codeEdt}
                                  isInvalid={valiteded && !details?.quizes?.[0]}
                                >
                                  <option value="" disabled>
                                    {quizList?.length > 0 ? "Select Quiz" : 'Quiz Not Added'}
                                  </option>
                                  {quizList?.length > 0 && quizList?.map((quiz, index) => (
                                    <option value={quiz?.quizId} key={index}>
                                      {quiz?.quizName}
                                    </option>
                                  ))}
                                </Form.Select>

                                <Form.Control.Feedback
                                  type="invalid"
                                  style={{ display: details.quizSource === "Saved Quiz" && valiteded && !details?.quizes?.[0] ? 'block' : 'none' }}
                                >
                                  Please Select Quiz
                                </Form.Control.Feedback>
                              </div>
                              <div className="col-md-1">
                                {/* {
                                    details.quizSource === 'Saved Quiz' && (quizList?.length === 0) && (
                                      <CustomButton
                                        title="Add"
                                        handleClick={addQuize}
                                        buttonType="buutonTertiory"
                                        isLoafing={false}
                                        isDisabled={details.quizSource !== 'Saved Quiz'}
                                      />
                                    )
                                  } */}
                              </div>


                            </Form.Group>

                          </>


                          <>
                            <h4 className="heading-group mt-3">
                              Custom Questions
                              <span className="job_size " >   (Answer is Yes/No only . leave blank if you wish to not use)</span>
                            </h4>
                            {
                              questions?.slice(0, 6)?.map((ques, idex) => {
                                const isLast = idex === questions?.length - 1
                                return <Form.Group
                                  key={idex}
                                  className="margin-btn-input"
                                  style={{ display: "flex", alignItems: "center" }}
                                >
                                  <Form.Label className="job_size col-md-2"
                                    style={{ display: "flex", alignItems: "center" }}
                                  >
                                    Question {idex + 1}
                                  </Form.Label>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      width: "90%",
                                      alignItems: 'center',
                                      gap: 12
                                    }}
                                  >
                                    <Form.Control
                                      style={{ width: "90%" }}
                                      type="text"
                                      value={ques?.questionText}
                                      className="input-text-14 col-md-9"
                                      onChange={(e) => {

                                        handelQuestion(idex, 'questionText', e.target.value, ques?.questionText)
                                      }
                                      }
                                      disabled={adminData?.admin != "Admin"}
                                    />
                                    <Tooltip
                                      title='Display Question For Candidate'
                                    >
                                      <Form.Check
                                        checked={ques.isActive}
                                        type="switch"
                                        id={"custom-switch" + idex}
                                        className="custom-switch"
                                        onChange={e => handelQuestion(idex, 'isActive', e.target.checked)}
                                        disabled={ques.questionText.trim() === '' || adminData?.admin != "Admin"}
                                      />
                                    </Tooltip>
                                    {isLast && (
                                      <Tooltip title='You Can Add Maximum 6 Questions'>
                                        <div style={{ transform: 'translate(-29%, 6%)', marginLeft: '6px' }}>
                                          <CustomButton
                                            title='Add'
                                            buttonType="buutonTertiory"
                                            isDisabled={questions.length >= 6 || adminData?.admin != "Admin"}
                                            handleClick={handleAddQuestion}
                                            paddingZero='true'
                                          />
                                        </div>
                                      </Tooltip>
                                    )}
                                  </div>

                                </Form.Group>

                              })
                            }
                            {
                              details?.isJDCode &&
                              <Form.Group
                                className="mt-2"
                                style={{ display: "flex" }}
                              >
                                <Form.Label className="job_size col-md-2"
                                >
                                  Other Examples
                                </Form.Label>
                                <div
                                  className="col-md-8 d-flex"
                                  style={{
                                    flex: 1,

                                    borderRadius: "5px",
                                    width: "90%",
                                  }}
                                >
                                  <Form.Control
                                    as="textarea"
                                    rows={6} // number of visible lines
                                    value={
                                      Array.isArray(questions)
                                        ? questions?.slice(6, 12)?.map(q => `• ${q?.questionText}`).join("\n")
                                        : ""
                                    }
                                    style={{ marginTop: '-5px' }}
                                    placeholder="Other Examples"
                                    className="textarea-placeholder-14 font-size-h4"
                                    disabled={true}
                                  />

                                </div>
                                <div className="col-md-1">
                                  
                                </div>


                              </Form.Group>
                            }


                          </> 

                        </>
                       } 
                      <h4 className=" heading-group mt-3">
                        Access and Control
                      </h4>
                      {details.reason === "Job Application" && (
                        <>
                          <Form.Group
                            className="margin-btn-input"
                            style={{ display: "flex", alignItems: "center", marginTop: '-6px' }}
                          >
                            <Form.Label className="job_size col-md-2 mt-2">
                              Outgoing Email
                            </Form.Label>
                            <div
                              className="col-md-8"
                              style={{
                                flex: 1,

                                borderRadius: "5px",
                                width: "90%",
                              }}
                            >
                              <Form.Select
                                className="input-text-14 font-size-h4"
                                value={details.from}
                                onChange={(e) =>
                                  handleChage("from", e.target.value)
                                }
                                disabled={adminData?.admin != "Admin"}
                              >
                                <option value="" selected disabled>
                                  Select Email
                                </option>
                                {emailList?.length > 0 &&
                                  emailList
                                    ?.filter((x) => x.verified === true)
                                    ?.map((email, index) => (
                                      <option
                                        value={email.from_Email}
                                        key={index}
                                      >
                                        {email.from_Email}
                                      </option>
                                    ))}
                              </Form.Select>
                            </div>
                            <div className="col-md-1"></div>
                          </Form.Group>
                        </>
                     )}
                      <Form.Group
                        className="margin-btn-input job_size"
                        style={{ display: "flex" }}
                      >
                        <Form.Label
                          className="col-md-2 mt-2"
                          style={{  }}
                        >
                          Collaborators Emails
                        </Form.Label>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: '2'
                          }}
                        >
                          <Form.Control
                            style={{ width: "100%" }}
                            // required={showEmails?.length === 0}
                            type="email"
                            disabled={isEdit && !permission?.isEdit}

                            // isInvalid={valiteded && showEmails.length}
                            placeholder="Type Email Here"
                            value={enterEmail}
                            onChange={(e) => setEnterEmail(e.target.value)}
                          // isInvalid={!!error}
                          />
                          {/* <Form.Control.Feedback type="invalid">
                            {showEmails?.length === 0 && 'Please Add Atleast 1 Email'}
                          </Form.Control.Feedback> */}
                          {/* <div
                            className=" mt-3"

                          >
                            {showEmails.map((email, index) => (
                              <span
                                className="addbackgroundcolor input-text-14 px-2 py-1 rounded-5 me-3 text-nowrap"
                                key={index}
                              >
                                {email?.email}
                                <button
                                  type="button"
                                  className="btn-close"
                                  style={{
                                    width: "5px",
                                    height: "7px",
                                    marginLeft: "4px",
                                    opacity: "0.8",
                                    // marginBottom: "-5px",
                                  }}
                                  onClick={() => removeEmail(index)}
                                ></button>
                              </span>
                            ))}
                          </div> */}
                          <CollaboratorsEmail showEmails={showEmails} removeEmail={removeEmail} setShowEmails={setShowEmails}
                            isEditDet={isEdit && !permission?.isEdit}
                          />

                        </div>
                        <div className="col-md-1 mt-2">
                          <CustomButton
                            title={'Add'}
                            handleClick={handleAddEmail}
                            buttonType="buutonTertiory"
                            isLoafing={false}
                            isDisabled={isEdit && !permission?.isEdit}
                          />
                        </div>
                      </Form.Group>


                    </div>
                   )} 
                </div>
                {/* <div className="col-4 border-round ">
                  <div  style={{border:"1px solid #e2e8f0",borderRadius:'6px',padding:'6px',marginLeft:'2px'}}>
                  {details.reason === "Job Application" && (
                    <>
                      {
                        <>
                           <div className="mt-2 d-flex justify-content-center">
                            <CustomButton
                              title={'Personality Selector'}
                              handleClick={()=>navigate('/testing')}
                              isDisabled={isEdit && !permission?.isEdit}
                            />
                          </div> 
                          <table className="text-base fw-bold group-table table table-hover mb-5 mt-1">
                            <thead>
                              <tr>
                                <td>Profile</td>
                                <td>Match 1</td>
                                <td>Match 2</td>
                              </tr>
                            </thead>
                            {console.log('initial_profile---', initialProfiles)}

                            <tbody>
                              {
                                profiles?.map((prof, index) => {
                                  return (
                                    <tr key={index} className="align-middle">
                                      <td className="job_size">{prof?.label}</td>

                                      <td>
                                        <div className="d-flex justify-content-center align-items-center">
                                          <Form.Control
                                            type="number"
                                            className="input-text-14 me-1 percentageFieldHeight padding-for-percentage"
                                            required
                                            style={{ width: "65px" }}
                                            ref={(el) => (inputRefs.current[index] = el)}
                                            disabled={adminData?.admin != "Admin"}
                                            onKeyDown={(e) => handleKeyDown(e, index)}
                                            value={initialProfiles[prof?.key]}
                                            onChange={(e) => {
                                              if (
                                                (Number(e.target.value) <= 100 &&
                                                  Number(e.target.value) >= 0) ||
                                                e.target.value === ""
                                              ) {
                                                handleProfiles(prof?.key, e.target.value);
                                              }
                                            }}
                                          />
                                          %
                                        </div>
                                      </td>

                                      <td>
                                        <div className="d-flex justify-content-center align-items-center">
                                          <Form.Control
                                            type="number"
                                            className="input-text-14 me-1 percentageFieldHeight padding-for-percentage"
                                            // required
                                            style={{ width: "65px" }}
                                            ref={(el) => (secoundRef.current[index] = el)}
                                            onKeyDown={(e) => handleKeyDown(e, index, true)}
                                            value={initialProfiles[prof?.key + '1']}
                                            disabled={adminData?.admin != "Admin"}
                                            onChange={(e) => {
                                              if (
                                                (Number(e.target.value) <= 100 &&
                                                  Number(e.target.value) >= 0) ||
                                                e.target.value === ""
                                              ) {
                                                handleProfiles(prof?.key + 1, e.target.value);
                                              }
                                            }}
                                          />
                                          %
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })
                              }
                            </tbody>
                          </table>


                            <div className="">
                <div
                            style={{
                              display: 'flex',
                              alignItems: 'center', // vertical center
                              justifyContent: 'flex-start', // optional (horizontal alignment)
                              gap: '8px',
                              marginLeft: '0px',
                              height: '40px' // optional, ensures visible alignment area
                            }}
                            className="d-flex justify-content-end"
                          >
                     

                            <div>
                              <CustomButton
                                title={'Supervisor Personality Selector'}
                                handleClick={() => setShowSuperVisior(true)}
                                isDisabled={isEdit && !permission?.isEdit}
                              />
                            </div>
                          </div>
                          {
                            details?.selectedSupervisorPersonality?.personalityName &&

                            <div
                              // key={i}
                              style={{
                                border: "1px solid #90EE90",
                                borderRadius: "12px",
                                marginBottom: "2px",
                                background: "#ffffff",
                                boxShadow: "0 6px 18px rgba(16, 24, 40, 0.06)",
                                padding: "8px",
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "12px",
                                cursor: "pointer",
                                transition: "transform 0.18s ease, box-shadow 0.18s ease",
                                minHeight: "140px",

                              }}
                              onMouseOut={(e) => {
                                e.currentTarget.style.transform = "none";
                                e.currentTarget.style.boxShadow =
                                  "0 6px 18px rgba(16,24,40,0.06)";
                              }}
                              className="mt-2 mb-2"
                            // onClick={() => handleShow(p.name)} 
                            >



                              <div style={{ flex: 1 }}>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "6px",
                                  }}
                                >
                                  <h3
                                    style={{
                                      fontSize: "var(--font-size-h3)",
                                      fontWeight: "600",
                                      margin: 0,
                                      color: "#111827",
                                    }}
                                  >
                                    {details?.selectedSupervisorPersonality?.personalityName}

                                  </h3>

                                </div>

                                <p
                                  style={{
                                    fontSize: "var(--font-size-base)",
                                    lineHeight: "1.45",
                                    color: "#4b5563",
                                    margin: 0,
                                  }}
                                >
                                  {details?.selectedSupervisorPersonality?.description}
                                </p>
                              </div>

                            </div>
                          }
                </div> 


                        </>
                      }
                      
                    </>
                   )} 
                  </div>
                </div> */}
               
              </div>
              </>)
              }
              {
                activeTab=='Screening Conditions'&&(
                  <ScreeningCondition 
                  screeningCondition={screeningCondition} 
                  setScreeningCondition={setScreeningCondition}
                  customQuestions = {questions?.filter((i)=>i?.isActive)?.map((i)=>({
                    label:i.questionText,
                    value:i.questionText,
                  }))}
                  industries={industryList}
                  isAiChatScreening={isAiscreening}
                  setIsAiChatScreening={setIsAiScreening}
                  />
                )
              }
              {
                activeTab === 'Personality Fitment' && (
              <div className="row">
                <BehaviorsPage setSelectedBehaviorFromApi={setSelectedBehaviorFromApi}
            isSuperVission={isSuperVission}
            setPersonalityMatchTwo={setPersonalityMatchTwo}
            selectedBehavoiurTwo={selectedBehavoiurTwo}
            setSelectedBehavoiurTwo={setSelectedBehavoiurTwo}
            selectedBehaviorFromApi={selectedBehaviorFromApi}
            modal={true}
            handleCloseBehaviour={handleClose}
            setPersonalityMatchingData={setPersonalityMatchingData}
            calucluatePersonalityPercentage={calucluatePersonalityPercentage}
            stressFrequency={details?.stressFrequency}
            handleSave={setDetails}
          />
          <SupervisiorPersonality
              selectedBehaviours={details?.supervisorBehaviours}
              setShowSuperVisior={setShowSuperVisior}
              handleSave={setDetails} supervisorPers={details?.selectedSupervisorPersonality?.personalityName}
              profilePer={initialProfiles}
              setInitialProfiles={setInitialProfiles}
              stressFrquency={details.superVisorImportance}
              hadlePayload={hadlePayload}
              setIsSuperVissorVlaseWithSave={setIsSuperVissorVlaseWithSave}
              isSuperVissorCloseWithSave={isSuperVissorCloseWithSave}
              details={details}
            />
                

              </div>
              
              )
              }
              {
                activeTab === 'Ai Chat Screening' && (
                  <ChatScreenConfig
                  config={config}
                  setConfig={setConfig}
                  />
                )
              }
              </div>
              <div className="mt-1 mb-2" style={{borderBottom:'2px solid rgb(229, 231, 235)'}}></div>
                <div className={`d-flex justify-content-between `}>
                  <div>
                  {

                    details.reason==='Job Application'&& activeTab!='Job Details'&&<CustomButton
                    buttonType='secondary'
                    title='Previous'
                    handleClick={()=>{
                      handleNavigation(false)
                    }}
                    />
                    }
                  </div>
                  
                  <button
                    className="btn btn-primary"
                    // style={{ marginRight: '0px',width:'100%' }}
                    type="submit"
                  >
                    
                  {
                    getButtonText()
                  }
                  </button>
                </div>
             
            </Form>
          </div>
        </div>
      </div >
      <Modal
        show={isAddCompany}
        centered
        onHide={() => setIsAddCompany(false)}
        size="lg"
        dialogClassName="modal-h-650"
      >
        <Modal.Header closeButton className="custom-close-btn p-4 pb-3">
          <h6 className="mb-0">{details?.companyId ? "Update" : "Add"} Company Details</h6>
        </Modal.Header>
        <Modal.Body className="p-4 pt-2">
          <div>
            <AddCompany
              isHandle={true}
              handleSubmitClose={() => handleAddCompamy()}
              id={details?.companyId}
              isUpdateAboutCompany={true}
              updateAboutCompany={(value, company) => {
                handleChage("aboutCompany", value);
                handleChage('company', company)
              }}
              isModal={true}
            />
          </div>
        </Modal.Body>
      </Modal>

      <>
        {/* {values.map((v, idx) => (
          <Button key={idx} className="me-2 mb-2" onClick={() => handleShow(v)}>
            Full screen
            {typeof v === 'string' && `below ${v.split('-')[0]}`}
          </Button>
        ))} */}
        <Modal show={show}  onHide={() => setShow(false)} className='p-0' dialogClassName="custom-modal-width">
          <Modal.Header closeButton>
            {/* <Modal.Title>Modal</Modal.Title> */}
          </Modal.Header>
          <Modal.Body><BehaviorsPage setSelectedBehaviorFromApi={setSelectedBehaviorFromApi}
            isSuperVission={isSuperVission}
            setPersonalityMatchTwo={setPersonalityMatchTwo}
            selectedBehavoiurTwo={selectedBehavoiurTwo}
            setSelectedBehavoiurTwo={setSelectedBehavoiurTwo}
            selectedBehaviorFromApi={selectedBehaviorFromApi}
            modal={true}
            handleCloseBehaviour={handleClose}
            setPersonalityMatchingData={setPersonalityMatchingData}
            calucluatePersonalityPercentage={calucluatePersonalityPercentage}
            stressFrequency={details?.stressFrequency}
            handleSave={setDetails}
          /></Modal.Body>
        </Modal>
        <Modal show={showSuperVisior} onHide={() => {
          setIsSuperVissorVlaseWithSave(true)
          // setShowSuperVisior(false)
        }

        } className='p-0' dialogClassName="custom-modal-width" >
          <Modal.Header closeButton>
            {/* <Modal.Title>Modal</Modal.Title> */}
          </Modal.Header>
          <Modal.Body>
            <SupervisiorPersonality
              selectedBehaviours={details?.supervisorBehaviours}
              setShowSuperVisior={setShowSuperVisior}
              handleSave={setDetails} supervisorPers={details?.selectedSupervisorPersonality?.personalityName}
              profilePer={initialProfiles}
              setInitialProfiles={setInitialProfiles}
              stressFrquency={details.superVisorImportance}
              hadlePayload={hadlePayload}
              setIsSuperVissorVlaseWithSave={setIsSuperVissorVlaseWithSave}
              isSuperVissorCloseWithSave={isSuperVissorCloseWithSave}

            />
          </Modal.Body>
        </Modal>
      </>
    </div >
  );
}

export default AddEditGroup;
